const TIME_VALUES = {
  ONE_SECOND_TO_MILLISECONDS: 1000,
  ONE_NANO_SECOND_TO_MILLISECONDS: 1000000
}

export { TIME_VALUES };